<template>
  <div id="exerciseCategoryList">
    <v-data-table
      :headers="headers"
      :items="exerciseCategoryList.data.data"
      :options.sync="options"
      :server-items-length="exerciseCategoryList.data.meta.total"
      :loading="exerciseCategoryList.loading"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 25, 50, 100],
      }"
    >
      <template v-slot:header.category="{ header }">
        <span class="font-medium text-base py-4" style="color: #222222">{{
          header.text
        }}</span>
      </template>

      <template v-slot:item.id="{ item }">
        <v-btn outlined class="mx-1">
          <span class="text-sm" @click="openEditCategory(item)">Edit</span>
        </v-btn>

        <v-btn
          outlined
          class="text-xs mx-1"
          @click="selectItem(item, 'delete')"
          :loading="
            selectedItem?.id === item.id &&
            selectedItemLoading &&
            pendingAction == 'delete'
          "
        >
          <span class="text-sm">Delete</span>
        </v-btn>
      </template>
    </v-data-table>

    <ConfirmModal
      :loading.sync="selectedItemLoading"
      title="Delete category"
      message="Do you want to delete this category?"
      v-model="showDeleteModal"
      @cancel="showDeleteModal = false"
      @confirm="handleDeleteConfirm"
    />

    <CategoryForm
      :show="showCategoryEditModal"
      :form="editCategoryValue"
      :loading="categoryLoading"
      :action="'update'"
      @onCancel="closeFormModal()"
      @onSave="editCategory()"
    />
  </div>
</template>

<script>
import Api from '@/services/api'
import { mapActions, mapState, mapMutations } from 'vuex'
import ConfirmModal from '@/components/modals/ConfirmModal'
import CategoryForm from '@/components/exercise/CategoryForm'

export default {
  name: 'CategoryList',
  components: {
    ConfirmModal,
    // CategoryFormModal,
    CategoryForm,
  },
  data() {
    return {
      options: {},
      openForm: false,
      selectedItem: null,
      pendingAction: '',
      selectedItemLoading: false,
      showDeleteModal: false,
      headers: [
        {
          text: 'Category',
          align: 'start',
          sortable: true,
          value: 'label',
        },
        {
          text: 'Actions',
          align: 'start',
          sortable: false,
          value: 'id',
        },
      ],
      showCategoryEditModal: false,
    }
  },
  watch: {
    options: {
      handler() {
        this.getExerciseCategories()
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      exerciseCategoryList: (state) => state.exerciseCategory.categoryList,
      editCategoryValue: (state) => state.exerciseCategory.editCategoryValue,
      categoryLoading: (state) => state.exerciseCategory.categoryLoading,
    }),
  },
  mounted() {
    this.getExerciseCategories()
  },
  methods: {
    ...mapActions({
      getExerciseCategoryList: 'exerciseCategory/getExerciseCategoryList',
      editExerciseCategory: 'exerciseCategory/editExerciseCategory',
    }),
    ...mapMutations({
      updateEditCategory: 'exerciseCategory/updateEditCategory',
      resetCategoryFormError: 'exerciseCategory/resetCategoryFormError',
    }),
    async getExerciseCategories() {
      let params = {
        page: this.options?.page ?? 1,
        per_page: this.options?.itemsPerPage ?? 10,
        sort: this.options.sortBy.map((sort, idx) =>
          this.options.sortDesc[idx] ? `-${sort}` : sort
        ),
      }

      await this.getExerciseCategoryList(params)
    },
    selectItem(exercise, action = '') {
      this.selectedItem = exercise

      if (action === 'delete') {
        this.showDeleteModal = true
      }

      if (action === 'edit') {
        this.$refs.form.setFormData(exercise)
        this.openForm = true
      }
    },
    async handleDeleteConfirm() {
      this.selectedItemLoading = true
      this.pendingAction = 'delete'

      try {
        await Api.delete(`exercise/categories/${this.selectedItem?.id}`)
        this.getExerciseCategories()

        this.$store.commit('setSnackbar', {
          show: true,
          color: 'success',
          text: 'Category successfully deleted.',
        })
      } catch ({ response: { data } }) {
        if (data.message) {
          this.$store.commit('setSnackbar', {
            show: true,
            color: 'error',
            text: data.message,
          })
        }
      } finally {
        this.selectedItem = null
        this.selectedItemLoading = false
        this.showDeleteModal = false
      }
    },
    closeFormModal() {
      this.showCategoryEditModal = false
      this.resetCategoryFormError()
    },
    openEditCategory(category) {
      this.updateEditCategory(category)
      this.showCategoryEditModal = true
    },
    editCategory() {
      this.editExerciseCategory(this.editCategoryValue).then(() => {
        if (!this.editCategoryValue.has_error) {
          this.showCategoryEditModal = false
        }
      })
    },
  },
}
</script>
